"use strict";

var _interopRequireDefault = require("/www/wwwroot/check/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
var _request = _interopRequireDefault(require("@/utils/request"));
var _request2 = _interopRequireDefault(require("@/utils/request4"));
var _RestTable = _interopRequireDefault(require("@/components/RestTable.vue"));
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _formatMixin = require("@/utils/formatMixin");
var _fileSaver = _interopRequireDefault(require("file-saver"));
var _default = exports.default = {
  components: {
    RestTable: _RestTable.default,
    Pagination: _index.default
  },
  mixins: [_formatMixin.formatMixin],
  data: function data() {
    return {
      // 顶部搜索框form数据
      formInline: {
        card_code: '',
        //搜索关键词
        real_name: '',
        mobile: '',
        type: '2,3',
        start_time: '',
        end_time: ''
      },
      dialogVisiblerisk: false,
      datenum: [],
      money: 0,
      // 商家余额
      moneyList: {
        count: 0
      },
      // 划扣流水
      listQuery: {
        page: 1,
        page_size: 10
      },
      listLoading: false,
      riskform: {
        real_name: '',
        card_code: '',
        mobile: ''
      },
      deviceType: 'desktop',
      // 设备类型: mobile, tablet, desktop
      dialogWidth: '30%',
      // 添加用户信息弹窗宽度
      labelPosition: 'right',
      // 标签位置
      labelWidth: '80px' // 标签宽度
    };
  },
  created: function created() {
    this.getMoneyList();
  },
  computed: {
    start_time: function start_time() {
      return this.datenum[0] ? this.formatDate(this.datenum[0]) : '';
    },
    end_time: function end_time() {
      return this.datenum[1] ? this.formatDate(this.datenum[1]) : '';
    }
  },
  mounted: function mounted() {
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice);
  },
  methods: {
    // 检测设备是否为移动端
    checkDevice: function checkDevice() {
      var clientWidth = document.documentElement.clientWidth;
      if (clientWidth <= 768) {
        // 移动设备
        this.deviceType = 'mobile';
        this.dialogWidth = '90%';
        this.labelPosition = 'top';
        this.labelWidth = '80px';
      } else if (clientWidth <= 1024) {
        // 平板设备
        this.deviceType = 'tablet';
        this.dialogWidth = '60%';
        this.labelPosition = 'right';
        this.labelWidth = '100px';
      } else {
        // 桌面设备
        this.deviceType = 'desktop';
        this.dialogWidth = '30%';
        this.labelPosition = 'right';
        this.labelWidth = '100px';
      }
    },
    // 格式化日期,需要加上时分秒的数据
    formatDate: function formatDate(date) {
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以要加1
      var day = String(date.getDate()).padStart(2, '0');
      var hour = String(date.getHours()).padStart(2, '0');
      var minute = String(date.getMinutes()).padStart(2, '0');
      var second = String(date.getSeconds()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hour, ":").concat(minute, ":").concat(second);
    },
    resetFilter: function resetFilter() {
      this.formInline.real_name = '';
      this.formInline.mobile = '';
      this.formInline.card_code = '';
      this.formInline.start_time = '';
      this.formInline.end_time = '';
      this.formInline.type = '2,3';
      this.datenum = [];
      this.getMoneyList();
    },
    // 搜索
    handleFilter: function handleFilter() {
      var _this = this;
      this.listLoading = true;
      // 王工封装
      // type 2 为支付宝账号流水
      (0, _request.default)({
        url: "/system/shopConfig/getUserRecord/",
        method: 'put',
        data: {
          shop_id: this.$user.data.shop,
          type: this.formInline.type,
          mobile: this.formInline.mobile,
          real_name: this.formInline.real_name,
          card_code: this.formInline.card_code,
          start_time: this.start_time,
          end_time: this.end_time
        }
      }).then(function (response) {
        if (response.data) {
          _this.moneyList = response.data.data;
        }
        _this.listLoading = false;
      });
    },
    DownExcel: function DownExcel() {
      var _this2 = this;
      this.listLoading = true;
      // 王工封装
      // type 2 为支付宝账号流水
      (0, _request2.default)({
        url: "/system/shopConfig/getUserRecordExcel/",
        method: 'put',
        responseType: 'blob',
        // 设置响应类型为 blob
        data: {
          shop_id: this.$user.data.shop,
          type: this.formInline.type,
          mobile: this.formInline.mobile,
          real_name: this.formInline.real_name,
          card_code: this.formInline.card_code,
          start_time: this.start_time,
          end_time: this.end_time
        }
      }).then(function (response) {
        console.log(response.data, '文件');
        // if (response.data) {
        //   this.moneyList = response.data.data
        // }
        var blob = new Blob([response.data], {
          type: 'application/vnd.ms-excel'
        });
        _fileSaver.default.saveAs(blob, 'user_record.xlsx'); // 保存文件
        _this2.listLoading = false;
      });
    },
    goRisk: function goRisk() {
      var _this3 = this;
      // 弹窗提示将消耗多少豆，确定后再查询
      this.$confirm("\u672C\u6B21\u67E5\u8BE2\u9884\u8BA1\u6D88\u8017<span style=\"color: red; font-weight: bold;\">1\u8C46/\u6B21</span>", '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(function () {
        // 王工封装
        // type 2 为支付宝账号流水
        (0, _request.default)({
          url: "/system/shopConfig/goRisk/",
          method: 'put',
          data: {
            shop_id: _this3.$user.data.shop,
            mobile: _this3.riskform.mobile,
            real_name: _this3.riskform.real_name,
            card_code: _this3.riskform.card_code
          }
        }).then(function (response) {
          _this3.dialogVisiblerisk = false;
          _this3.getMoneyList();
          // this.listLoading = false
        });
      }).catch(function () {
        _this3.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    // 获取划扣流水——done
    getMoneyList: function getMoneyList() {
      var _this4 = this;
      this.listLoading = true;
      // 王工封装
      // type 2 为支付宝账号流水
      (0, _request.default)({
        url: "/system/shopConfig/getUserRecord/",
        method: 'put',
        data: {
          shop_id: this.$user.data.shop,
          type: this.formInline.type,
          mobile: this.formInline.mobile,
          real_name: this.formInline.real_name,
          card_code: this.formInline.card_code,
          start_time: this.start_time,
          end_time: this.end_time
        }
      }).then(function (response) {
        if (response.data) {
          _this4.moneyList = response.data.data;
        }
        _this4.listLoading = false;
      });
    }
  }
};